var boostAI_DefaultSortingValue={sorting:"Sorting",sorting_best_selling:"Best Selling",sorting_featured:"Featured",sorting_heading:"Sorting",sorting_manual:"Manual",sorting_relevance:"Relevance",sorting_created_ascending:"Created Ascending",sorting_created_descending:"Created Descending",sorting_date_ascending:"Date Ascending",sorting_date_descending:"Date Descending",sorting_published_descending:"Published Descending",sorting_published_ascending:"Published Ascending",sorting_price_ascending:"Price Ascending",sorting_price_descending:"Price Descending",sorting_sale_ascending:"% Off",sorting_sale_descending:"% Off, Low to High",sorting_title_ascending:"Title Ascending",sorting_title_descending:"Title Descending"};try{if("undefined"!=typeof boostPFSThemeConfig&&boostPFSThemeConfig.hasOwnProperty("label"))for(var key in boostPFSThemeConfig.label){if(boostPFSThemeConfig.label.hasOwnProperty(key)&&"string"==typeof boostPFSThemeConfig.label[key])-1!==(value=boostPFSThemeConfig.label[key].toLowerCase()).indexOf("translation missing")&&void 0!==boostAI_DefaultSortingValue[key]&&(boostPFSThemeConfig.label[key]=boostAI_DefaultSortingValue[key])}if("undefined"!=typeof bcSfFilterConfig&&bcSfFilterConfig.hasOwnProperty("label"))for(var key in bcSfFilterConfig.label){var value;if(bcSfFilterConfig.label.hasOwnProperty(key)&&"string"==typeof bcSfFilterConfig.label[key])-1!==(value=bcSfFilterConfig.label[key].toLowerCase()).indexOf("translation missing")&&void 0!==boostAI_DefaultSortingValue[key]&&(bcSfFilterConfig.label[key]=boostAI_DefaultSortingValue[key])}}catch(e){console.log("Patch defaultSortingValue error")}

/* --- SEO patch 20260727: 商品リンクからコレクション接頭辞を除去し /products/xxx に正規化 --- */
if (typeof BoostPFS != 'undefined' && BoostPFS.prototype) {
	BoostPFS.prototype.buildProductItemUrl = function (product) {
		var root = (typeof Shopify != 'undefined' && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
		if (!product || !product.handle) { return root; }
		return root + 'products/' + product.handle;
	};
}
(function () {
	var RX = /\/collections\/[^\/?#]+\/products\//;
	function fixIn(node) {
		if (!node || !node.querySelectorAll) { return; }
		var links = node.querySelectorAll('a[href*="/collections/"][href*="/products/"]');
		for (var i = 0; i < links.length; i++) {
			var h = links[i].getAttribute('href');
			if (h && RX.test(h)) { links[i].setAttribute('href', h.replace(RX, '/products/')); }
		}
		if (node.nodeType === 1 && node.tagName === 'A') {
			var s = node.getAttribute('href');
			if (s && RX.test(s)) { node.setAttribute('href', s.replace(RX, '/products/')); }
		}
	}
	function start() {
		fixIn(document);
		if (!window.MutationObserver || !document.body) { return; }
		new MutationObserver(function (muts) {
			for (var i = 0; i < muts.length; i++) {
				var added = muts[i].addedNodes;
				for (var j = 0; j < added.length; j++) {
					if (added[j].nodeType === 1) { fixIn(added[j]); }
				}
			}
		}).observe(document.body, { childList: true, subtree: true });
	}
	if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
/* --- end SEO patch --- */

var boostPFS = new BoostPFS();
boostPFS.init(); 
if (typeof boostPFSConfig != 'undefined'
	&& typeof boostPFSConfig.general != 'undefined' 
	&& typeof boostPFSConfig.general.isInitFilter != 'undefined'
	&& typeof boostPFSThemeConfig != 'undefined'
	&& boostPFSConfig.general.isInitFilter === true) {
	boostPFS.initFilter(); 
} 
BoostPFS.jQ(window).on('load', function(){
	boostPFS.initSearchBox();
	false && boostPFS.initAnalytics();
});